import { NgModule } from "@angular/core";
import { DynamicFormsModule } from "../../dynamic-forms/dynamic-forms.module";
import { ButtonModule } from "../button/button.module";
import { GridModule } from "../grid/grid.module";
import { MenuModule } from "../menu/menu.module";
import { MemberSearchComponent } from "./member-search.component";

@NgModule({
    imports: [
        ButtonModule,
        DynamicFormsModule,
        GridModule,
        MenuModule,
    ],
    declarations: [
        MemberSearchComponent,
    ],
    exports: [
        MemberSearchComponent,
    ],
})

export class MemberSearchModule { }
